import { render, staticRenderFns } from "./MobileRedEnvelopeError.vue?vue&type=template&id=020bf92f&"
import script from "./MobileRedEnvelopeError.vue?vue&type=script&lang=js&"
export * from "./MobileRedEnvelopeError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.2.47_css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10._l5tjryxt4u4rxr5bwadgd7nxke/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports